
 
 <div class="container-fluid"> 
    <app-header></app-header>
    

    <div class="row mt-3 d-flex justify-content-center signup-card">
        <div class="col-lg-3 col-xs-12 col-sm-12 col-md-4 col-md-mid-lg-4">
            <div class="text-center  box-white">
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="home-box-white white-bg pt-0 pl-4 pr-4">
                    <h6 class="text-left ft-size-18 pt-4"><b>inStore    </b> <br> <b> Cashier Checkout Portal </b></h6>  
                    
                    <p class="pt-4  text-left ft-size-16">Enter the total amount</p>

                    <div class="form-group instore row">
                        <div class="pull-left text-left col-lg-2"><b class="ft-size-18 line-h-40">LKR</b></div><div class="pull-right col-lg-10"> <input type="text"  class=" form-control  gray-bg border-radious-reset no-border font-amount-fix"  formControlName="productValue" > </div>
                    </div>
                    <div class="form-group instore">
                        <p class="text-left pt-3 ft-size-16">Enter a customer mobile number (optional)</p>
                         <div > <input type="text" class="form-control  gray-bg border-radious-reset no-border"   formControlName="mobileNo" > </div>
                    </div>
                    <div class="form-group instore ">
                        <p class="text-left pt-3 ft-size-16">Enter a reference code (optional)</p>
                        <div > <input type="text" class="form-control  gray-bg border-radious-reset no-border" formControlName="merchantRef"> </div>
                   </div>

                   <div class="form-group instore pt-4 pb-4"> 
                       <button class="form-control send-payment border-radious-reset no-border"  type="submit"  [disabled]="!loginForm.valid"> <b>SEND PAYMENT REQUEST</b> </button>
                    </div>

                    <div *ngIf="this.isSubmitting" class="alert alert-danger">
                        {{  errors | translate }}
                    </div>
                </div>
                </form> 
            </div>
        </div>
        <div class="col-lg-9 col-xs-12 col-sm-9 col-md-9 col-md-mid-lg-8"> 
            &nbsp;
        </div>
    </div>
 
  
</div>


<div class="foter-mr-pd-fix">
    <app-footer></app-footer>
</div>